import React from "react";
import { Category, Requirement } from "../../../../src/CommonFunctions";
import {
  ClothingSizeSelector,
  StyleOptionSelector,
  ColorSelector,
} from "../../../pages/ImprovedShopPage/SingleProductPageHelpers";
import DropDown from "../OptionChooser/Dropdown";
import TextInput from "../OptionChooser/TextInput";
import "../../../pages/ImprovedShopPage/styles/SingleProductPage.css";
import { ImprovedParticipantShop } from "../../../Interfaces/FundraiserRole";
interface ProductOptionsProps {
  orderRequirements: Requirement[];
  category: Category;
  clothingSizes: Record<
    string,
    Array<{ db_name: string; display_name: string; up_charge: number }>
  >;
  productSKU: string;
  clothingSize: string | undefined;
  setClothingSize: (size: string | undefined) => void;
  clothingCustomization: string | undefined;
  setClothingCustomization: (customization: string | undefined) => void;
  customTextFieldActive: boolean;
  fontStyle: string | undefined;
  setFontStyle: (font: string | undefined) => void;
  customText: string | undefined;
  setCustomText: (text: string | undefined) => void;
  style: string;
  setStyle: (style: string) => void;
  availableFonts: string[];
  customizationOptions: Array<{ text: string; upcharge: number }>;
  selectedColor: string | undefined;
  setSelectedColor: (color: string | undefined) => void;
  setProductSKU: (sku: string) => void;
  shopInfo: ImprovedParticipantShop;
}

export const ProductOptions: React.FC<ProductOptionsProps> = ({
  orderRequirements,
  category,
  clothingSizes,
  productSKU,
  clothingSize,
  setClothingSize,
  clothingCustomization,
  setClothingCustomization,
  customTextFieldActive,
  fontStyle,
  setFontStyle,
  customText,
  setCustomText,
  style,
  setStyle,
  availableFonts,
  customizationOptions,
  selectedColor,
  setSelectedColor,
  setProductSKU,
  shopInfo,
}) => {
  return (
    <>
      {orderRequirements.map((requirement, index) => (
        <div key={index}>
          {requirement === Requirement.Style && (
            <StyleOptionSelector
              category={category}
              selectedOption={style}
              setSelectedOption={setStyle}
              shopInfo={shopInfo}
              isOrg={false}
            />
          )}
          {requirement === Requirement.Color && (
            <ColorSelector
              shopInfo={shopInfo}
              selectedOption={selectedColor}
              setSelectedOption={setSelectedColor}
              selectedCategory={style || ""}
              setSku={setProductSKU}
            />
          )}
          {requirement === Requirement.Size && (
            <ClothingSizeSelector
              clothing_sizes={clothingSizes}
              sku={productSKU}
              selectedOption={clothingSize}
              setSelectedOption={setClothingSize}
            />
          )}
          {requirement === Requirement.ClothingCustomization && (
            <DropDown
              options={customizationOptions.reduce<Record<string, string>>(
                (acc, option) => ({
                  ...acc,
                  [option.text]: option.text,
                }),
                {},
              )}
              selectedOption={clothingCustomization || ""}
              setSelectedOption={(value: string | undefined) =>
                setClothingCustomization(value || undefined)
              }
              optionDescription="Choose a clothing customization option:"
            />
          )}
          {requirement === Requirement.FontStyle && (
            <DropDown
              options={availableFonts.reduce<Record<string, string>>(
                (acc, font) => ({
                  ...acc,
                  [font]: font,
                }),
                {},
              )}
              selectedOption={fontStyle || ""}
              setSelectedOption={(value: string | undefined) =>
                setFontStyle(value || undefined)
              }
              optionDescription="Choose a font style:"
            />
          )}
          {requirement === Requirement.CustomizationText && (
            <TextInput
              label="Enter your text"
              value={customText || ""}
              onChange={setCustomText}
              isDisabled={!customTextFieldActive}
              placeholder="Type here..."
            />
          )}
        </div>
      ))}
    </>
  );
};

export default ProductOptions;
